import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';

export type GridBoxT = BoxT & {
  gridGap?: React.CSSProperties['gridGap'];
  gridTemplateColumns?: React.CSSProperties['gridTemplateColumns'];
};

export const GridBox = ({
  gridGap,
  gridTemplateColumns,
  extend,
  ...props
}: GridBoxT) => {
  return (
    <Box
      width="100%"
      {...props}
      display="grid"
      extend={({ theme }) => ({
        gridGap,
        gridTemplateColumns,
        ...(extend ? extend({ theme }) : {}),
      })}
    ></Box>
  );
};
